import { __extends, __rest, __assign, __makeTemplateObject } from 'tslib';
import React, { Component, forwardRef } from 'react';
import classnames from 'classnames';
import { styled } from 'styled-components';
import { IconClose } from 'suomifi-icons';
import { getLogger } from '../../../utils/log/logger.js';
import '../../../reset/HtmlA/HtmlA.js';
import { HtmlButton } from '../../../reset/HtmlButton/HtmlButton.js';
import '../../../reset/HtmlDiv/HtmlDiv.js';
import '../../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../../reset/HtmlH/HtmlH.js';
import '../../../reset/HtmlInput/HtmlInput.js';
import '../../../reset/HtmlLabel/HtmlLabel.js';
import '../../../reset/HtmlLegend/HtmlLegend.js';
import '../../../reset/HtmlLi/HtmlLi.js';
import '../../../reset/HtmlNav/HtmlNav.js';
import '../../../reset/HtmlOl/HtmlOl.js';
import { HtmlSpan } from '../../../reset/HtmlSpan/HtmlSpan.js';
import '../../../reset/HtmlTextarea/HtmlTextarea.js';
import '../../../reset/HtmlUl/HtmlUl.js';
import '../../../reset/HtmlTable/HtmlTable.js';
import '../../../reset/HtmlTable/HtmlTableCaption.js';
import '../../../reset/HtmlTable/HtmlTableHeader.js';
import '../../../reset/HtmlTable/HtmlTableRow.js';
import '../../../reset/HtmlTable/HtmlTableBody.js';
import '../../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../../reset/HtmlTable/HtmlTableCell.js';
import { separateMarginProps } from '../../theme/utils/spacing.js';
import { VisuallyHidden } from '../../VisuallyHidden/VisuallyHidden.js';
import { baseClassName, chipClassNames } from '../BaseChip/BaseChip.js';
import { baseStyles } from './Chip.baseStyles.js';
import { SuomifiThemeConsumer } from '../../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../../theme/SuomifiTheme/SuomifiTheme.js';
import { SpacingConsumer } from '../../theme/SpacingProvider/SpacingProvider.js';
import { filterDuplicateKeys } from '../../../utils/common/common.js';

var chipButtonClassNames = {
  removable: "".concat(baseClassName, "--removable"),
  button: "".concat(baseClassName, "--button"),
  icon: "".concat(baseClassName, "--icon")
};
var DefaultChip = function (_super) {
  __extends(DefaultChip, _super);
  function DefaultChip() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  DefaultChip.prototype.render = function () {
    var _a;
    var _b = this.props,
      className = _b.className,
      children = _b.children,
      onClick = _b.onClick,
      removable = _b.removable,
      actionLabel = _b.actionLabel,
      forwardedRef = _b.forwardedRef,
      _c = _b.disabled,
      disabled = _c === void 0 ? false : _c,
      _d = _b["aria-disabled"],
      ariaDisabled = _d === void 0 ? false : _d,
      style = _b.style,
      rest = __rest(_b, ["className", "children", "onClick", "removable", "actionLabel", "forwardedRef", "disabled", 'aria-disabled', "style"]);
    var _e = separateMarginProps(rest),
      passProps = _e[1];
    var onClickProp = !!disabled || !!ariaDisabled ? {} : {
      onClick: onClick
    };
    if (removable && !actionLabel) {
      getLogger().error('Provide actionLabel to communicate removability to screen readers');
    }
    return /*#__PURE__*/React.createElement(HtmlButton, __assign({
      className: classnames(baseClassName, chipButtonClassNames.button, className, (_a = {}, _a[chipClassNames.disabled] = !!disabled || !!ariaDisabled, _a[chipButtonClassNames.removable] = !!removable, _a)),
      disabled: disabled,
      "aria-disabled": !!ariaDisabled || !!disabled
    }, onClickProp, {
      forwardedRef: forwardedRef
    }, passProps, {
      style: style
    }), /*#__PURE__*/React.createElement(HtmlSpan, {
      className: chipClassNames.content
    }, children), !!removable && ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconClose, {
      mousePointer: true,
      color: "currentColor",
      className: chipButtonClassNames.icon,
      "aria-hidden": true
    }), /*#__PURE__*/React.createElement(VisuallyHidden, null, actionLabel))));
  };
  return DefaultChip;
}(Component);
var StyledChip = styled(function (_a) {
  _a.theme;
    _a.globalMargins;
    var passProps = __rest(_a, ["theme", "globalMargins"]);
  return /*#__PURE__*/React.createElement(DefaultChip, __assign({}, passProps));
}).withConfig({
  componentId: "sc-1whmkdc-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    globalMargins = _a.globalMargins,
    rest = __rest(_a, ["theme", "globalMargins"]);
  var _b = separateMarginProps(rest),
    marginProps = _b[0];
  var cleanedGlobalMargins = filterDuplicateKeys(globalMargins.chip, marginProps);
  return baseStyles(theme, cleanedGlobalMargins, marginProps);
});
var Chip = /*#__PURE__*/forwardRef(function (props, ref) {
  var passProps = __rest(props, []);
  return /*#__PURE__*/React.createElement(SpacingConsumer, null, function (_a) {
    var margins = _a.margins;
    return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
      var suomifiTheme = _a.suomifiTheme;
      return /*#__PURE__*/React.createElement(StyledChip, __assign({
        theme: suomifiTheme,
        globalMargins: margins,
        forwardedRef: ref
      }, passProps));
    });
  });
});
Chip.displayName = 'Chip';
var templateObject_1;

export { Chip };
//# sourceMappingURL=Chip.js.map
